import { captureException } from '@sentry/react'
import { flushSync } from 'react-dom'

// Borrowed from https://github.com/TanStack/router/blob/21743e263df6eb08c3685ffea937d3c4a1637eed/packages/react-router/src/router.ts#L1844-L1853
export const startViewTransition = (callback: () => void) => {
    if (
        typeof document !== 'undefined' &&
        'startViewTransition' in document &&
        typeof document.startViewTransition === 'function' &&
        document.visibilityState === 'visible'
    ) {
        const transition = document.startViewTransition(() => {
            // eslint-disable-next-line @eslint-react/dom-no-flush-sync
            flushSync(callback)
        })

        // Aborted view transitions (such as when a dialog interrupts a transition) could cause unhandled promise rejections to appear in Sentry.
        // This ensures these errors are safely ignored, both in the utility function and in Sentry's error allowlist
        transition.finished.catch((error: unknown) => {
            if (
                error instanceof DOMException &&
                (error.name === 'InvalidStateError' || error.name === 'AbortError' || error.name === 'TimeoutError')
            ) {
                return
            }

            captureException(error)
        })
    } else {
        callback()
    }
}
